import { useState, useEffect } from 'react'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { formatDate, getAllData, subtractDays } from '../../shared/constants'

const TopKbcReport = () => {
  const [state, setState] = useState({
    data: [],
    loading: false,
    paginate: false,
    downloadData: false,
  })

  const filterData = state.data
  const [page, setPage] = useState(1)

  //? useEffect
  useEffect(() => {
    getAllData('GET_TOP_KBC_REPORT', { page: page, limit: 10 }, state, setState)
  }, [page])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  console.log({ filterData })
  console.log({ state })

  if (!state.loading && filterData.length > 0) {
    tableBody = filterData.map((item, index) => {
      return [
        { value: item?.employee },
        { value: item?.region },
        { value: item?.zone },
        { value: item?.zone },
        { value: item?.regionRank },
        { value: item?.zoneRank },
        { value: item?.total },
        { value: item?.attendance },
        { value: item?.sales },
        { value: item?.learning },
        { value: item?.audit },
      ]
    })
  }

  const layoutProps = {
    heading: 'Top Kbc Report',
    filename: 'topKbcReport',
    headers: state.downloadData.headings,
    data: state.downloadData.headingValues,
  }

  return (
    <CustomTableLayout
      tableHeadings={['Employee', 'Region', 'Region Rank', 'Zone', 'Region Rank', 'Zone Rank', 'Total Score', 'Attendence', 'Sales', 'Learning', 'Audit']}
      loading={state.loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: state.paginate.totalPage, page: page }}
      layoutProps={layoutProps}
    />
  )
}

export default TopKbcReport
